module.exports = __webpack_public_path__ + "media/packs/users/img/footer/fa-home-solid-553c492b39abff11534909932725aa92.svg";